import * as React from 'react';
import styles from './index.less';
import { Tabs } from 'antd';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, StorageObjectEditorModelState } from '@/models/connect';
import FResourceSelector from './FResourceSelector';
import FObjectSelector from './FObjectSelector';
import {
  AddObjectDepOAction,
  AddObjectDepRAction,
  DeleteObjectDepOAction,
  DeleteObjectDepRAction,
} from '@/models/storageObjectEditor';
import { FUtil } from '@freelog/tools-lib';

interface SelectDepsProps {
  dispatch: Dispatch;
  storageObjectEditor: StorageObjectEditorModelState;
}

function SelectDeps({ storageObjectEditor, dispatch }: SelectDepsProps) {
  const [$activeTab, set$ActiveTab] = FUtil.Hook.useGetState<'resource' | 'object'>('resource');

  return (
    <div>
      <div className={styles.tabs}>
        <div
          className={[styles.tabs_item, $activeTab === 'resource' ? styles.active : ''].join(' ')}
          onClick={() => {
            set$ActiveTab('resource');
          }}
        >
          资源
        </div>
        <div
          className={[styles.tabs_item, $activeTab === 'object' ? styles.active : ''].join(' ')}
          onClick={() => {
            set$ActiveTab('object');
          }}
        >
          对象
        </div>
      </div>
      {$activeTab === 'resource' && (
        <FResourceSelector
          selectedResourceIDs={storageObjectEditor.depRs.map((r) => {
            return r.id;
          })}
          onSelect={(value: { id: string }) => {
            dispatch<AddObjectDepRAction>({
              type: 'storageObjectEditor/addObjectDepR',
              payload: value.id,
            });
          }}
          onDelete={(value: { name: string }) => {
            dispatch<DeleteObjectDepRAction>({
              type: 'storageObjectEditor/deleteObjectDepR',
              payload: value.name,
            });
          }}
        />
      )}

      {$activeTab === 'object' && (
        <FObjectSelector
          selectedObjectIDs={storageObjectEditor.depOs.map((o) => {
            return o.id;
          })}
          onSelect={(value: { id: string }) => {
            dispatch<AddObjectDepOAction>({
              type: 'storageObjectEditor/addObjectDepO',
              payload: value.id,
            });
          }}
          onDelete={(value: { name: string }) => {
            dispatch<DeleteObjectDepOAction>({
              type: 'storageObjectEditor/deleteObjectDepO',
              payload: value.name,
            });
          }}
        />
      )}
    </div>
  );
  // return (
  //   <div>
  //     <Tabs>
  //       <Tabs.TabPane tab='资源' key='1'>
  //         <FResourceSelector
  //           selectedResourceIDs={storageObjectEditor.depRs.map((r) => {
  //             return r.id;
  //           })}
  //           onSelect={(value: { id: string }) => {
  //             dispatch<AddObjectDepRAction>({
  //               type: 'storageObjectEditor/addObjectDepR',
  //               payload: value.id,
  //             });
  //           }}
  //           onDelete={(value: { name: string }) => {
  //             dispatch<DeleteObjectDepRAction>({
  //               type: 'storageObjectEditor/deleteObjectDepR',
  //               payload: value.name,
  //             });
  //           }}
  //         />
  //       </Tabs.TabPane>
  //       <Tabs.TabPane tab='对象' key='2'>
  //         <FObjectSelector
  //           selectedObjectIDs={storageObjectEditor.depOs.map((o) => {
  //             return o.id;
  //           })}
  //           onSelect={(value: { id: string }) => {
  //             dispatch<AddObjectDepOAction>({
  //               type: 'storageObjectEditor/addObjectDepO',
  //               payload: value.id,
  //             });
  //           }}
  //           onDelete={(value: { name: string }) => {
  //             dispatch<DeleteObjectDepOAction>({
  //               type: 'storageObjectEditor/deleteObjectDepO',
  //               payload: value.name,
  //             });
  //           }}
  //         />
  //       </Tabs.TabPane>
  //     </Tabs>
  //   </div>
  // );
}

export default connect(({ storageObjectEditor }: ConnectState) => ({
  storageObjectEditor: storageObjectEditor,
}))(SelectDeps);
